import {
  AspectRatioType,
  ButtonContentType,
  ContentType,
  CssProperties,
  ImageData,
} from "@/states/page-editor/template-parts/common";

export type TopTemplateType = "top.1";

export type ServiceDisplayOrderType = "system" | "custom";

export enum ServiceDisplayOrderMode {
  SYSTEM = "system",
  CUSTOM = "custom",
}

export const DISPLAY_ORDER_LABEL: Record<ServiceDisplayOrderMode, string> = {
  [ServiceDisplayOrderMode.SYSTEM]: "システム固定順",
  [ServiceDisplayOrderMode.CUSTOM]: "自由設定",
};

export interface TopTemplateBase {
  id: string;
  type: TopTemplateType;
  image?: ImageData;
  aspectRatio?: AspectRatioType;
  image_uuid?: ImageData;
  title: ContentType;
  description: ContentType;
  buttonContent: ButtonContentType;
  frameCssProperties?: CssProperties;
  bgCssProperties: CssProperties;
  hiddenIds?: number[];
  serviceDisplayOrderType?: ServiceDisplayOrderType;
  serviceOrderIds?: number[];
}

export type TopTypeTemplate = TopTemplateBase;
